import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=6a3aef62&"
import script from "./EmailVerification.vue?vue&type=script&lang=ts&"
export * from "./EmailVerification.vue?vue&type=script&lang=ts&"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=6a3aef62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports